import { render, staticRenderFns } from "./AdminManagementAdminsExtra.vue?vue&type=template&id=874a7dbe&scoped=true&"
import script from "./AdminManagementAdminsExtra.vue?vue&type=script&lang=js&"
export * from "./AdminManagementAdminsExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874a7dbe",
  null
  
)

export default component.exports